import { Text } from '@podiumhq/design-system';

import { useSelectPlanCheckoutContext } from 'contexts/SelectPlanCheckoutContextProvider';

import { confirmDetailsTextStyles } from '../styles';

import { ConfirmDetailsSectionWrapper } from './ConfirmDetailsSectionWrapper';

const ContactDetails = (props) => {
  const { userDetails = {} } = useSelectPlanCheckoutContext();
  const { email = '', firstName = '', lastName = '', phone = '' } = userDetails;

  return (
    <ConfirmDetailsSectionWrapper
      displayDivider
      title="Contact Details"
      id="fs-contact-details-change"
      {...props}
    >
      <Text {...confirmDetailsTextStyles}>{`${firstName} ${lastName}`}</Text>
      <Text {...confirmDetailsTextStyles}>{email}</Text>
      <Text {...confirmDetailsTextStyles}>{phone}</Text>
    </ConfirmDetailsSectionWrapper>
  );
};

export default ContactDetails;
